(ns common.ui.tabs
  (:require ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            [common.util :refer [spread-obj]]
            [reagent.core :as r]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui tabs [{:keys [tabs bind-active-tab-to-query-param sx]}]
  (let [query-tab (keyword (:tab (use-subscribe [:router/query-parameters-pre-coercion])))
        ;; Only keeps that value when we want to bind the active tab to the query param "tab",
        ;; and when it is pointing to a valid tab. Otherwise, keeps nil.
        query-tab (when (and bind-active-tab-to-query-param
                             (contains? tabs query-tab))
                    query-tab)

        [active-tab set-active-tab] (uix/use-state (or query-tab
                                                       (key (first tabs))))]
    ;; Make the current tab follow the tab named in the query param, if any.
    (uix/use-effect (fn []
                      (when (and (some? query-tab)
                                 (not= active-tab query-tab))
                        (set-active-tab query-tab)))
                    [active-tab query-tab])
    ($ :<>
       ($ Tabs {:value (name active-tab)
                :on-change (fn [_e v]
                             (let [tab (keyword v)]
                               (if bind-active-tab-to-query-param
                                 ;; Set the query param to the newly active tab id, which will
                                 ;; in turn change the active-tab value via the effect above.
                                 (rfe/set-query (fn [query-params]
                                                  (assoc query-params :tab tab)))
                                 (set-active-tab tab))))
                :sx (spread-obj #js {:backgroundColor "grey.90"
                                     :px 3}
                                sx)}
          (for [[tab-key {:keys [label label-element icon disabled?]}] tabs]
            ($ Tab (cond-> {:key tab-key
                            :value tab-key
                            :disabled disabled?
                            :label (or label-element ($ :span label))
                            :data-testid (str "tab-button-" label)}
                     (some? icon) (assoc :icon ($ Icon {:font-size "small"} icon)
                                         :icon-position "start")))))
       (r/as-element (get-in tabs [active-tab :content])))))
